var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnlineicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33301 7.58113L12.3798 9.61229C12.4237 9.64152 12.4747 9.65829 12.5274 9.66081C12.5801 9.66333 12.6325 9.65151 12.679 9.62661C12.7255 9.60171 12.7644 9.56466 12.7915 9.5194C12.8186 9.47415 12.833 9.42239 12.833 9.36963V4.58863C12.833 4.53731 12.8195 4.48689 12.7938 4.44247C12.7681 4.39805 12.7311 4.3612 12.6866 4.33564C12.6421 4.31007 12.5917 4.2967 12.5404 4.29688C12.489 4.29705 12.4387 4.31076 12.3943 4.33663L9.33301 6.12279",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#4F46E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33366 3.5H8.16699C8.81132 3.5 9.33366 4.02233 9.33366 4.66667V9.33333C9.33366 9.97767 8.81132 10.5 8.16699 10.5H2.33366C1.68933 10.5 1.16699 9.97767 1.16699 9.33333V4.66667C1.16699 4.02233 1.68933 3.5 2.33366 3.5Z",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#4F46E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineicon);
export default __webpack_public_path__ + "static/media/onlineicon.be7dc2922be2cde44fbe04e57d5d2c0c.svg";
export { ForwardRef as ReactComponent };